import { type ReactNode } from "react";

export type ChipProps = {
  children: ReactNode;
  tone?: "neutral" | "accent" | "good" | "warn" | "bad";
  size?: "sm" | "md";
};

const TONE = {
  neutral: "border-line text-ink-soft bg-canvas-2",
  accent:  "border-accent/30 text-accent-ink bg-accent-soft",
  good:    "border-good/30 text-good bg-good/10",
  warn:    "border-warn/30 text-warn bg-warn/10",
  bad:     "border-bad/30 text-bad bg-bad/10",
} as const;

const SIZE = {
  sm: "text-xs px-2 py-0.5",
  md: "text-sm px-2.5 py-1",
} as const;

export function Chip({ children, tone = "neutral", size = "sm" }: ChipProps) {
  return (
    <span className={`inline-flex items-center rounded-md border ${TONE[tone]} ${SIZE[size]} font-medium`}>
      {children}
    </span>
  );
}
